import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calculations-quality-of-life',
  templateUrl: './calculations-quality-of-life.component.html',
  styleUrls: ['./calculations-quality-of-life.component.css']
})
export class CalculationsQualityOfLifeComponent implements OnInit {

  window_ref = window as any;

  distribution_map = {
    1: "Determinista", 2: "Normal", 3: "Lognormal", 4: "Gamma", 5: "Beta"
  };

  constructor() { }

  ngOnInit() { }

}
